import { useState } from "react";
import { Link } from "react-router-dom";
import {
  FiMapPin,
  FiPhone,
  FiClock,
  FiMessageCircle,
  FiShield,
  FiTruck,
  FiRefreshCw,
  FiFileText,
  FiSearch
} from "react-icons/fi";
import Nav from "../../components/home/Nav";
import Footer from "../../components/home/landing/Footer";

const supportPhone = "09176427900";
const baleUrl = "https://ble.ir/kafshjooti";
const rubikaUrl = "https://rubika.ir/dayyerjooti";
const whatsappUrl = `https://wa.me/98${supportPhone.slice(1)}`;

const pages = {
  about: {
    icon: FiShield,
    kicker: "درباره جوتی",
    title: "جوتی؛ فروشگاه کفش و صندل زنانه",
    description:
      "جوتی / Jooti Style از سال ۱۳۹۸ در بندر دیر فعالیت خود را آغاز کرده و تمرکز اصلی آن روی کفش، صندل و محصولات مرتبط با استایل زنانه است.",
    sections: [
      {
        title: "جوتی یعنی چه؟",
        body: [
          "واژه «جوتی» در گویش محلی جنوب ایران، به‌ویژه در بخش‌هایی از استان بوشهر و مناطق بندری، به معنی کفش به کار می‌رود. انتخاب این نام برای فروشگاه، اشاره‌ای به هویت محلی و ارتباط مستقیم فروشگاه با دنیای کفش و پاپوش دارد."
        ]
      },
      {
        title: "ما چه محصولاتی ارائه می‌کنیم؟",
        body: [
          "تمرکز فروشگاه جوتی بر عرضه کفش و صندل زنانه است. دسته‌بندی‌های اصلی فروشگاه شامل اسپورت، صندل زنانه، کفش مجلسی و کفش پرسنلی است.",
          "هدف ما این است که مشتری بتواند با خیال راحت محصول مناسب خود را انتخاب کند و در صورت نیاز از پشتیبانی فروشگاه برای انتخاب سایز، مدل و پیگیری سفارش کمک بگیرد."
        ]
      },
      {
        title: "تعهد جوتی",
        body: [
          "ما در جوتی به کیفیت کالا، پاسخگویی مناسب و تجربه خرید مطمئن اهمیت می‌دهیم. در صورت وجود شرایط مرجوعی یا تعویض، مشتری می‌تواند حداکثر تا ۴۸ ساعت پس از دریافت مرسوله، درخواست خود را از طریق پشتیبانی ثبت کند."
        ]
      }
    ]
  },
  contact: {
    icon: FiPhone,
    kicker: "تماس با ما",
    title: "راه‌های ارتباط با فروشگاه جوتی",
    description:
      "برای پشتیبانی سفارش، مشاوره خرید، پیگیری ارسال یا ثبت درخواست تعویض و مرجوعی می‌توانید از راه‌های زیر با ما در ارتباط باشید.",
    contact: true,
    sections: [
      {
        title: "اطلاعات فروشگاه",
        body: [
          "نام فروشگاه: جوتی / Jooti Style",
          "مالک فروشگاه: حسن فولادی",
          "آدرس: بندر دیر، انتهای خیابان مخابرات، نرسیده به خیابان ساحلی، روبروی مسجد امام حسن",
          "کد پستی: ۷۵۵۴۱۵۳۶۹۳",
          "ساعات پاسخگویی: هر روز از ساعت ۹ صبح تا ۱۰ شب"
        ]
      },
      {
        title: "پشتیبانی",
        body: [
          `شماره پشتیبانی: ${supportPhone}`,
          "کانال ما در پیام‌رسان‌های داخلی: بله و روبیکا",
          "واتساپ: شماره پشتیبانی فروشگاه"
        ]
      }
    ]
  },
  terms: {
    icon: FiFileText,
    kicker: "قوانین و مقررات",
    title: "قوانین استفاده و خرید از جوتی",
    description:
      "ثبت سفارش در سایت جوتی به معنی مطالعه و پذیرش قوانین و مقررات فروشگاه است.",
    sections: [
      {
        title: "ثبت سفارش و پرداخت",
        body: [
          "تمام قیمت‌ها در سایت به تومان نمایش داده می‌شوند.",
          "پس از پرداخت موفق، سفارش وارد مرحله بررسی و آماده‌سازی می‌شود.",
          "مشتری موظف است هنگام ثبت سفارش، اطلاعات تماس، آدرس و کد پستی را به‌درستی وارد کند. مسئولیت تأخیر یا مشکل در ارسال به دلیل اطلاعات نادرست، بر عهده مشتری است."
        ]
      },
      {
        title: "لغو سفارش و بازگشت وجه",
        body: [
          "لغو سفارش پیش از ارسال کالا با هماهنگی پشتیبانی امکان‌پذیر است.",
          "در صورت تأیید لغو سفارش، وجه فقط به همان کارت یا حسابی بازگردانده می‌شود که پرداخت از طریق آن انجام شده است.",
          "در صورت ناموجود شدن کالا پس از ثبت سفارش، فروشگاه موضوع را به مشتری اطلاع می‌دهد و مبلغ پرداختی به همان کارتی که پرداخت از آن انجام شده است بازگردانده می‌شود یا با هماهنگی مشتری، کالای جایگزین ارسال می‌شود."
        ]
      },
      {
        title: "کد تخفیف و خطای سیستمی",
        body: [
          "استفاده از کد تخفیف تابع شرایط همان کد است و ممکن است محدود به زمان، محصول، دسته‌بندی، کاربر یا مبلغ مشخصی باشد.",
          "فروشگاه جوتی حق دارد در صورت بروز خطای سیستمی، خطای قیمت‌گذاری یا مشکل موجودی، سفارش را بررسی و با اطلاع‌رسانی به مشتری اصلاح یا لغو کند."
        ]
      }
    ]
  },
  privacy: {
    icon: FiShield,
    kicker: "حریم خصوصی",
    title: "حفظ اطلاعات کاربران",
    description:
      "جوتی اطلاعات کاربران را فقط برای ثبت سفارش، ارسال کالا، ورود امن، پشتیبانی و اطلاع‌رسانی‌های ضروری استفاده می‌کند.",
    sections: [
      {
        title: "چه اطلاعاتی دریافت می‌شود؟",
        body: [
          "اطلاعاتی که ممکن است از کاربر دریافت شود شامل نام و نام خانوادگی، شماره موبایل، آدرس، کد پستی، اطلاعات سفارش و اطلاعات لازم برای ارسال کالا است.",
          "شماره موبایل کاربر برای ورود به حساب کاربری، ارسال کد تأیید، اطلاع‌رسانی ثبت سفارش، تغییر وضعیت سفارش و پیگیری سفارش استفاده می‌شود."
        ]
      },
      {
        title: "اطلاعات پرداخت",
        body: [
          "اطلاعات کارت بانکی کاربران در سایت جوتی ذخیره نمی‌شود و پرداخت از طریق درگاه پرداخت بانکی یا پرداخت‌یار انجام می‌شود.",
          "فروشگاه جوتی اطلاعات کاربران را جز برای پردازش سفارش، ارسال کالا، ارسال پیامک‌های ضروری، پشتیبانی مشتری و الزامات قانونی، در اختیار اشخاص غیرمرتبط قرار نمی‌دهد."
        ]
      },
      {
        title: "اصلاح اطلاعات",
        body: [
          "کاربران می‌توانند برای اصلاح اطلاعات تماس یا آدرس خود با پشتیبانی فروشگاه تماس بگیرند.",
          "فروشگاه جوتی تلاش می‌کند از اطلاعات کاربران به‌صورت امن نگهداری کند و از آن فقط در چارچوب خدمات فروشگاه استفاده کند."
        ]
      }
    ]
  },
  shipping: {
    icon: FiTruck,
    kicker: "رویه ارسال",
    title: "ارسال سفارش‌های جوتی",
    description:
      "سفارش‌های ثبت‌شده در فروشگاه جوتی پس از پرداخت موفق، بررسی و آماده ارسال می‌شوند.",
    sections: [
      {
        title: "روش و زمان ارسال",
        body: [
          "روش‌های ارسال سفارش ممکن است شامل پست، تیپاکس، ارسال پس‌کرایه یا سایر روش‌های قابل انتخاب در زمان ثبت سفارش باشد.",
          "زمان آماده‌سازی سفارش معمولاً بین ۱ تا ۳ روز کاری است. زمان تحویل نهایی بسته به شهر مقصد و روش ارسال متفاوت خواهد بود."
        ]
      },
      {
        title: "هزینه ارسال",
        body: [
          "هزینه ارسال در زمان ثبت سفارش نمایش داده می‌شود. در برخی شرایط، ارسال رایگان یا پس‌کرایه نیز ممکن است فعال باشد.",
          "مسئولیت وارد کردن آدرس، کد پستی و شماره تماس صحیح بر عهده مشتری است. در صورت برگشت خوردن مرسوله به دلیل اطلاعات اشتباه، هزینه ارسال مجدد بر عهده مشتری خواهد بود."
        ]
      },
      {
        title: "پیگیری سفارش",
        body: [
          "برای پیگیری وضعیت سفارش، مشتری می‌تواند از طریق حساب کاربری یا راه‌های ارتباطی پشتیبانی با فروشگاه تماس بگیرد."
        ]
      }
    ]
  },
  returns: {
    icon: FiRefreshCw,
    kicker: "تعویض و مرجوعی",
    title: "شرایط تعویض و مرجوعی کالا",
    description:
      "مشتریان جوتی می‌توانند حداکثر تا ۴۸ ساعت پس از تحویل مرسوله، درخواست تعویض یا مرجوعی کالا را از طریق پشتیبانی ثبت کنند.",
    sections: [
      {
        title: "شرایط قابل قبول",
        body: [
          "کالا استفاده نشده باشد.",
          "کالا آسیب ندیده باشد.",
          "جعبه، بسته‌بندی، لیبل و متعلقات کالا سالم باشد.",
          "کالا بوی عطر، مواد شوینده یا آثار استفاده نداشته باشد."
        ]
      },
      {
        title: "تعویض سایز و مدل",
        body: [
          "در صورتی که سایز کالا مناسب نباشد، مشتری از کیفیت کالا رضایت نداشته باشد یا مدل کالا مورد پسند مشتری نباشد، امکان تعویض یا مرجوعی وجود دارد؛ مشروط بر اینکه کالا در شرایط اولیه و سالم باشد.",
          "تعویض سایز در صورت موجود بودن سایز جایگزین امکان‌پذیر است."
        ]
      },
      {
        title: "موارد غیرقابل مرجوع",
        body: [
          "کالاهای استفاده‌شده، آسیب‌دیده توسط مشتری، بدون بسته‌بندی اصلی یا دارای آثار استفاده، قابل مرجوعی یا تعویض نیستند.",
          "اگر بعداً کالاهای دارای شرایط بهداشتی خاص به فروشگاه اضافه شوند، شرایط مرجوعی آن‌ها جداگانه اعلام خواهد شد."
        ]
      },
      {
        title: "هزینه ارسال و بازگشت وجه",
        body: [
          "اگر مشکل از طرف فروشگاه باشد، هزینه ارسال مرجوعی یا تعویض بر عهده فروشگاه است.",
          "اگر تعویض یا مرجوعی به درخواست مشتری و بدون خطای فروشگاه باشد، هزینه ارسال بر عهده مشتری خواهد بود.",
          "پس از دریافت و بررسی کالا توسط فروشگاه، در صورت تأیید مرجوعی، مبلغ سفارش به همان حساب یا شماره شبای متعلق به خریدار بازگردانده می‌شود."
        ]
      }
    ]
  },
  "order-tracking": {
    icon: FiSearch,
    kicker: "پیگیری سفارش",
    title: "پیگیری وضعیت سفارش",
    description:
      "برای مشاهده سفارش‌ها وارد حساب کاربری خود شوید یا از طریق پشتیبانی جوتی وضعیت سفارش را پیگیری کنید.",
    tracking: true,
    sections: [
      {
        title: "پیگیری از حساب کاربری",
        body: [
          "اگر سفارش را از طریق حساب کاربری ثبت کرده‌اید، می‌توانید از بخش سفارش‌های من وضعیت سفارش و جزئیات آن را مشاهده کنید."
        ]
      },
      {
        title: "پیگیری از پشتیبانی",
        body: [
          `برای پیگیری سریع‌تر، شماره سفارش یا شماره موبایلی که با آن خرید انجام شده را به پشتیبانی ارسال کنید. شماره پشتیبانی: ${supportPhone}`,
          "ساعات پاسخگویی: هر روز از ساعت ۹ صبح تا ۱۰ شب"
        ]
      }
    ]
  }
};

const ContactCards = () => (
  <div className="static-contact-grid">
    <a href={`tel:${supportPhone}`} className="static-contact-card">
      <FiPhone />
      <span>شماره پشتیبانی</span>
      <strong>{supportPhone}</strong>
    </a>

    <a href={whatsappUrl} target="_blank" rel="noreferrer" className="static-contact-card">
      <FiMessageCircle />
      <span>واتساپ</span>
      <strong>{supportPhone}</strong>
    </a>

    <a href={baleUrl} target="_blank" rel="noreferrer" className="static-contact-card">
      <FiMessageCircle />
      <span>کانال بله</span>
      <strong>kafshjooti</strong>
    </a>

    <a href={rubikaUrl} target="_blank" rel="noreferrer" className="static-contact-card">
      <FiMessageCircle />
      <span>کانال روبیکا</span>
      <strong>dayyerjooti</strong>
    </a>

    <div className="static-contact-card">
      <FiClock />
      <span>ساعات پاسخگویی</span>
      <strong>۹ صبح تا ۱۰ شب</strong>
    </div>

    <div className="static-contact-card static-contact-card-wide">
      <FiMapPin />
      <span>آدرس فروشگاه</span>
      <strong>بندر دیر، انتهای خیابان مخابرات، نرسیده به خیابان ساحلی، روبروی مسجد امام حسن</strong>
    </div>
  </div>
);

const toEnglishDigits = (value = "") => {
  const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
  const arabicDigits = "٠١٢٣٤٥٦٧٨٩";

  return String(value)
    .replace(/[۰-۹]/g, (digit) => persianDigits.indexOf(digit))
    .replace(/[٠-٩]/g, (digit) => arabicDigits.indexOf(digit));
};

const normalizeMobile = (value = "") => {
  let mobile = toEnglishDigits(value).replace(/[^0-9+]/g, "");

  if (mobile.startsWith("+98")) {
    mobile = `0${mobile.slice(3)}`;
  } else if (mobile.startsWith("98") && mobile.length === 12) {
    mobile = `0${mobile.slice(2)}`;
  } else if (mobile.startsWith("9") && mobile.length === 10) {
    mobile = `0${mobile}`;
  }

  return mobile;
};

const translateContactError = (message = "") => {
  const text = String(message || "").trim();

  if (!text) return "خطا در ثبت پیام";

  const lower = text.toLowerCase();

  if (lower.includes("mobile") && lower.includes("format")) {
    return "شماره موبایل معتبر نیست.";
  }

  if (lower.includes("mobile") && (lower.includes("required") || lower.includes("ضروری"))) {
    return "شماره موبایل را وارد کنید.";
  }

  if (lower.includes("message") && lower.includes("at least")) {
    return "متن پیام باید حداقل ۵ کاراکتر باشد.";
  }

  if (lower.includes("message") && lower.includes("required")) {
    return "متن پیام را وارد کنید.";
  }

  if (lower.includes("full_name") || lower.includes("full name")) {
    return "نام و نام خانوادگی را وارد کنید.";
  }

  if (lower.includes("subject") && lower.includes("required")) {
    return "موضوع پیام را وارد کنید.";
  }

  if (lower.includes("validation")) {
    return "اطلاعات فرم را بررسی کنید.";
  }

  return text;
};


const ContactForm = () => {
  const [form, setForm] = useState({
    full_name: "",
    mobile: "",
    subject: "",
    message: ""
  });
  const [status, setStatus] = useState({
    type: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);

  const updateField = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: field === "mobile" ? normalizeMobile(value) : value
    }));
  };

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const payload = {
        ...form,
        mobile: normalizeMobile(form.mobile),
        full_name: form.full_name.trim(),
        subject: form.subject.trim(),
        message: form.message.trim()
      };

      const response = await fetch("/api/contact-messages", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const firstKey = data?.errors ? Object.keys(data.errors)[0] : null;
        const errorMessage = firstKey ? data.errors[firstKey]?.[0] : data?.message;
        throw new Error(translateContactError(errorMessage || data?.message || "خطا در ثبت پیام"));
      }

      setForm({
        full_name: "",
        mobile: "",
        subject: "",
        message: ""
      });
      setStatus({
        type: "success",
        message: data?.message || "پیام شما با موفقیت ثبت شد."
      });
    } catch (error) {
      setStatus({
        type: "error",
        message: translateContactError(error.message || "خطا در ثبت پیام")
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="static-contact-form" onSubmit={submit}>
      <div className="static-contact-form-head">
        <span>فرم تماس</span>
        <h2>پیام خود را برای ما بنویسید</h2>
        <p>برای پیگیری سریع‌تر، شماره سفارش یا شماره موبایل خرید را هم بنویسید.</p>
      </div>

      <div>
        <label>نام و نام خانوادگی</label>
        <input
          type="text"
          placeholder="نام شما"
          value={form.full_name}
          onChange={(event) => updateField("full_name", event.target.value)}
        />
      </div>

      <div>
        <label>شماره موبایل</label>
        <input
          type="tel"
          placeholder="مثلاً ۰۹۱۲۳۴۵۶۷۸۹"
          value={form.mobile}
          onChange={(event) => updateField("mobile", event.target.value)}
        />
      </div>

      <div>
        <label>موضوع پیام</label>
        <input
          type="text"
          placeholder="موضوع درخواست"
          value={form.subject}
          onChange={(event) => updateField("subject", event.target.value)}
        />
      </div>

      <div className="static-form-full">
        <label>متن پیام</label>
        <textarea
          placeholder="پیام خود را بنویسید"
          value={form.message}
          onChange={(event) => updateField("message", event.target.value)}
        />
      </div>

      {status.message && (
        <div className={`static-form-alert ${status.type}`}>
          {status.message}
        </div>
      )}

      <button type="submit" disabled={loading}>
        {loading ? "در حال ارسال..." : "ارسال پیام"}
      </button>
    </form>
  );
};

const StaticPage = ({ type }) => {
  const page = pages[type] || pages.about;
  const Icon = page.icon;

  return (
    <>
      <Nav />

      <main className="static-page">
        <section className="static-hero">
          <div className="site-container">
            <div className="static-hero-card">
              <span className="static-kicker">
                <Icon />
                {page.kicker}
              </span>

              <h1>{page.title}</h1>
              <p>{page.description}</p>

              <div className="static-hero-actions">
                <Link to="/products">مشاهده محصولات</Link>
                <Link to="/contact">ارتباط با پشتیبانی</Link>
              </div>
            </div>
          </div>
        </section>

        <section className="static-content">
          <div className="site-container">
            {page.contact ? (
              <div className="static-contact-layout">
                <div className="static-contact-main">
                  <ContactForm />
                </div>

                <aside className="static-contact-side">
                  <ContactCards />

                  <div className="static-contact-info-list">
                    {page.sections.map((section) => (
                      <article className="static-section-card" key={section.title}>
                        <h2>{section.title}</h2>

                        {section.body.map((item) => (
                          <p key={item}>{item}</p>
                        ))}
                      </article>
                    ))}
                  </div>
                </aside>
              </div>
            ) : (
              page.sections.map((section) => (
                <article className="static-section-card" key={section.title}>
                  <h2>{section.title}</h2>

                  {section.body.map((item) => (
                    <p key={item}>{item}</p>
                  ))}
                </article>
              ))
            )}

            {page.tracking && (
              <div className="static-action-box">
                <Link to="/orders">مشاهده سفارش‌های من</Link>
                <a href={whatsappUrl} target="_blank" rel="noreferrer">پیگیری از واتساپ</a>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default StaticPage;
